var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pageDashboard"}},[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-label',[_vm._v("Today Trackings")]),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"lg3":"","sm6":"","xs12":""}},[_c('mini-statistic',{attrs:{"icon":"fa fa-user","title":String(_vm.today.students),"sub-title":"Students","color":"blue"}})],1),_c('v-flex',{attrs:{"lg3":"","sm6":"","xs12":""}},[_c('mini-statistic',{attrs:{"icon":"fa fa-user","title":String(_vm.today.staff),"sub-title":"Staff","color":"indigo"}})],1),_c('v-flex',{attrs:{"lg3":"","sm6":"","xs12":""}},[_c('mini-statistic',{attrs:{"icon":"fa fa-user","title":String(_vm.today.visitors),"sub-title":"Visitors","color":"pink"}})],1),_c('v-flex',{attrs:{"lg3":"","sm6":"","xs12":""}},[_c('mini-statistic',{attrs:{"icon":"fa fa-user","title":String(_vm.today.contractors),"sub-title":"Contractors","color":"green"}})],1),_c('v-flex',{attrs:{"lg8":"","sm12":"","xs12":""}},[_c('v-widget',{attrs:{"title":"Weekly Report","content-bg":"white"}},[_c('v-btn',{attrs:{"slot":"widget-header-action","icon":""},slot:"widget-header-action"},[_c('v-icon',{staticClass:"text--secondary",on:{"click":function($event){return _vm.showAttendanceCount()}}},[_vm._v("refresh")])],1),_c('div',{attrs:{"slot":"widget-content"},slot:"widget-content"},[(_vm.showChart)?_c('e-chart',{attrs:{"path-option":[
                ['dataset.source', _vm.attendances],
                [
                  'color',
                  [
                    _vm.color.blue.base,
                    _vm.color.indigo.base,
                    _vm.color.pink.base,
                    _vm.color.green.base
                  ]
                ],
                ['legend.show', true],
                ['xAxis.axisLabel.show', true],
                ['yAxis.axisLabel.show', true],
                ['grid.left', '2%'],
                ['grid.bottom', '5%'],
                ['grid.right', '3%'],
                ['series[0].type', 'bar'],
                ['series[0].areaStyle', {}],
                ['series[0].smooth', true],
                ['series[1].smooth', true],
                ['series[1].type', 'bar'],
                ['series[1].areaStyle', {}],
                ['series[2].smooth', true],
                ['series[2].type', 'bar'],
                ['series[2].areaStyle', {}],
                ['series[3].smooth', true],
                ['series[3].type', 'bar'],
                ['series[3].areaStyle', {}]
              ],"height":"400px","width":"100%"}}):_vm._e()],1)],1)],1),_c('v-flex',{attrs:{"lg4":"","sm12":"","xs12":""}},[_c('v-widget',{attrs:{"title":"Attendance","content-bg":"white"}},[_c('div',{attrs:{"slot":"widget-content"},slot:"widget-content"},[(_vm.showChart)?_c('e-chart',{attrs:{"path-option":[
                ['dataset.source', _vm.locationData],
                ['legend.bottom', '0'],
                [
                  'color',
                  [
                    _vm.color.lightBlue.base,
                    _vm.color.indigo.base,
                    _vm.color.pink.base,
                    _vm.color.green.base,
                    _vm.color.cyan.base,
                    _vm.color.teal.base
                  ]
                ],
                ['xAxis.show', false],
                ['yAxis.show', false],
                ['series[0].type', 'pie'],
                ['series[0].avoidLabelOverlap', true],
                ['series[0].radius', ['50%', '70%']]
              ],"height":"400px","width":"100%"}}):_vm._e()],1)])],1),_c('v-flex',{attrs:{"lg4":"","sm12":"","xs12":""}},[_c('plain-table-emergency')],1),_c('v-flex',{attrs:{"lg4":"","sm12":"","xs12":""}},[_c('plain-table')],1),_c('v-flex',{attrs:{"lg4":"","sm12":"","xs12":""}},[_c('plain-table-resources')],1),_c('v-flex')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }